import * as React from 'react'

import { ContentEpisodeFaqRow as Presenter, IProps } from './presenter'
export const ContentEpisodeFaqRow = ({
  question,
  answer,
  answerNote,
  ...props
}: Omit<IProps, 'accordionOpen' | 'accordionClickHandler'>): JSX.Element => {
  const [accordionOpen, setAccordionOpen] = React.useState<boolean>(false)
  const accordionClickHandler = () => {
    setAccordionOpen(!accordionOpen)
  }
  return (
    <Presenter
      question={question}
      answer={answer}
      answerNote={answerNote}
      accordionOpen={accordionOpen}
      accordionClickHandler={accordionClickHandler}
    />
  )
}

export default ContentEpisodeFaqRow
